import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, InputAdornment, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Modal, OutlinedInput } from '@mui/material'
import { ValidateInt } from '../../../../../../../../../../core/validator/Validator'
import { Remove } from '@mui/icons-material'
import { AddBox1 } from '../../../../../../../../../../core/global/Icons'
import { NumericFormat } from 'react-number-format'
import React, { useEffect, useState, useContext } from 'react'
import { domain, env } from '../../../../../../../../../../core/Env'
import { rqx } from '../../../../../../../../../../core/request/API'
import VisibilityIcon from '@mui/icons-material/Visibility';
import PickupAddressModal from './../modal/PickupAddressModal';
import ConfirmAddressModal from './../modal/ConfirmAddressModal';
import GoogleMapPicker, { getAddressFromLatLng } from '../modal/GoogleMap'
import { ToolContext } from '../../../../../../../../../../core/context/ToolContext'

const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
const ubr_pickup_address = JSON.parse(localStorage.getItem('pickup_address'))

export const Content = ({ inputs, handlerChange, product_state }) => {
    const { tool_state } = useContext(ToolContext)
    const { userId, __SESSION } = tool_state
    const { prodTemplate, categoryList, subCategory, pickupAddresses, selectedPickupAddress } = product_state
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [barangay, setBarangay] = useState([]);
    const [provinceLoading, setProvinceLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);
    const [barangayLoading, setBarangayLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [isDefault, setIsDefault] = useState(false);
    const [isEnable, setIsEnable] = useState(true);
    const [pickupModal, setPickupModal] = useState({ open: false, mode: 'add' });
    const [pickupCoordinates, setPickupCoordinates] = useState(null);
    const [selectedAddressDetails, setSelectedAddressDetails] = useState(null);
    const [confirmAddressModalOpen, setConfirmAddressModalOpen] = useState(false);
    const [isGoogleMapsMode, setIsGoogleMapsMode] = useState(false);

    const [shippingRates, setShippingRates] = useState(null);
    const [deliveryValidationError, setDeliveryValidationError] = useState('');
    const vehicleOptions = [
        { value: "1", label: "Motorcycle", key: "motorcycle" },
        { value: "2", label: "UV (S)", key: "uv_small" },
        { value: "3", label: "UV (L)", key: "uv_large" }
        // Add more in future here
    ];

    const handleOpen = () => {
        setOpen(true);
        prodTemplate.set({
            ...prodTemplate.data,
            inputs: {
                ...prodTemplate.data.inputs,
                street_name: { value: '', stat: false, msg: '' },
                area_name: { value: '', stat: false, msg: '' },
                pickup_province: { value: '', stat: false, msg: '' },
                pickup_city: { value: '', stat: false, msg: '' },
                pickup_barangay: { value: '', stat: false, msg: '' },
                pickup_place_id: { value: '', stat: false, msg: '' }
            }
        });
    };

    // Fetch provinces on mount
    const getProvince = async () => {
        try {
            setProvinceLoading(true);
            const res_province = await rqx.get(`<<global>>/${env()}/location/province`, { ref: 'id', filter: 'all' });
            if (res_province) {
                setProvinces(res_province)
            }
            setProvinceLoading(false);
        } catch (error) {
            console.log(error)
        }
        setProvinceLoading(false);
    }

    // Fetch cities when province changes
    const getCity = async () => {
        try {
            if (inputs?.pickup_province?.value) {
                setCityLoading(true);
                const res_city = await rqx.get(`<<global>>/${env()}/location/city`, { ref: 'province_id', filter: JSON.stringify([inputs?.pickup_province?.value]) });
                if (Array.isArray(res_city)) {
                    setCities(res_city);
                } else {
                    setCities([]);
                }
                setCityLoading(false);
            } else {
                setCities([]);
            }
        } catch (error) {
            console.log(error)
        }
        setCityLoading(false);
    }

    const getBarangay = async () => {
        try {
            if (inputs?.pickup_city?.value) {
                setBarangayLoading(true);
                const res_barangay = await rqx.get(`<<global>>/${env()}/location/barangay`, { ref: 'city_id', filter: JSON.stringify([inputs?.pickup_city?.value]) });
                if (res_barangay) {
                    setBarangay(res_barangay)
                }
                setBarangayLoading(false);
            } else {
                setBarangay([]);
            }
        } catch (error) {
            console.log(error)
        }
        setBarangayLoading(false);
    }

    const fetchProvinceById = async (id) => {
        try {
            const res = await rqx.get(`<<global>>/${env()}/location/province`, { ref: 'id', filter: JSON.stringify([id]) });
            if (res && res.length > 0) {
                setProvinces(prev => [...prev, res[0]]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchCityById = async (id) => {
        try {
            const res = await rqx.get(`<<global>>/${env()}/location/city`, { ref: 'id', filter: JSON.stringify([id]) });
            if (res && res.length > 0) {
                setCities(prev => [...prev, res[0]]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchBarangayById = async (id) => {
        try {
            const res = await rqx.get(`<<global>>/${env()}/location/barangay`, { ref: 'id', filter: JSON.stringify([id]) });
            if (res && res.length > 0) {
                setBarangay(prev => [...prev, res[0]]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchPickupAddress = async () => {
        if (hcrmSession ) {
            const address = []
            const pickupView = await rqx.get(`<<tool>>/${env()}/template/view_pickup_details`, { user_id: userId.data })
            const res = await rqx.get(`<<biz>>/${env()}/biz/branch/read`, { company_id: __SESSION.data.uaccess[0].company_id, filter: 'all' })
            if (pickupView.pickup.length > 0 && res.length > 0) {
                pickupView.pickup.forEach(view => {
                    res.forEach(addr => {
                        if (view.company_branch_id === addr.id) {
                            address.push({
                                ...addr,
                                ...view
                            })
                        }
                    })
                })
                pickupAddresses.set(address)
            }
        }
    }
    console.log(pickupAddresses.data)
    const handlerDetails = (action, index) => {
        let details = [...inputs.promo_details]
        if (action === 'add') {
            prodTemplate.set({ ...prodTemplate.data, inputs: { ...inputs, promo_details: [...details, { value: '', stat: false, msg: '', toggled: false }] } })
            return
        }
        details.splice(index, 1)
        prodTemplate.set({ ...prodTemplate.data, inputs: { ...inputs, promo_details: details } })
    }

    const validateDisc = (e) => {
        if (e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== '.') {
            if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
            }
        }
    }

    const handlerCheck = (e) => {
        const { name, checked } = e.target
        prodTemplate.set({ ...prodTemplate.data, inputs: { ...inputs, [name]: { ...inputs.partial, toggled: checked, value: checked ? inputs.partial.value : '', stat: true } } })
    }

    const fetchAllShippingRates = async () => {
        try {
            const response = await rqx.get(`<<tool>>/${env()}/template/read_shipping_rates`);
            if (response && response.shipping_rates) {
                setShippingRates(response.shipping_rates);
            }
        } catch (error) {
            console.error('Failed to fetch shipping rates, using defaults:', error);
            // Keep the default shipping rates defined in state
        }
    };

    useEffect(() => {
        getProvince();
        fetchPickupAddress();
        fetchAllShippingRates();
    }, [])

    useEffect(() => {
        if (pickupAddresses.data && pickupAddresses.data.length > 0) {
            const defaultIdx = pickupAddresses.data.findIndex(addr => addr?.is_default === 1);
            if (defaultIdx !== -1) {
                selectedPickupAddress.set(defaultIdx);
            } else {
                selectedPickupAddress.set(pickupAddresses.data.length - 1);
            }
        } else {
            selectedPickupAddress.set(null);
        }
    }, [pickupAddresses.data]);

    useEffect(() => {
        getCity()
    }, [inputs?.pickup_province?.value])

    useEffect(() => {
        getBarangay()
    }, [inputs?.pickup_city?.value])

    useEffect(() => {
        if (
            inputs?.pickup_province?.value &&
            !provinces.some(prov => prov.id === inputs.pickup_province.value)
        ) {
            fetchProvinceById(inputs.pickup_province.value);
        }
    }, [inputs?.pickup_province?.value, provinces]);

    useEffect(() => {
        if (
            inputs?.pickup_city?.value &&
            !cities.some(city => city.id === inputs.pickup_city.value)
        ) {
            fetchCityById(inputs.pickup_city.value);
        }
    }, [inputs?.pickup_city?.value, cities]);

    useEffect(() => {
        if (
            inputs?.pickup_barangay?.value &&
            !barangay.some(b => b.id === inputs.pickup_barangay.value)
        ) {
            fetchBarangayById(inputs.pickup_barangay.value);
        }
    }, [inputs?.pickup_barangay?.value, barangay]);

    const validateProductAgainstVehicle = (vehicleRate, productSpecs) => {
        const { weight, length, width, height } = productSpecs;

        // Convert string values to numbers for comparison
        const productWeight = parseFloat(weight) || 0;
        const productLength = parseFloat(length) || 0;
        const productWidth = parseFloat(width) || 0;
        const productHeight = parseFloat(height) || 0;

        // Check weight constraint
        if (vehicleRate.weight_limit_per_kg && productWeight > vehicleRate.weight_limit_per_kg) {
            return false;
        }

        // Check dimension constraints if they exist
        if (vehicleRate.length && productLength > vehicleRate.length) return false;
        if (vehicleRate.width && productWidth > vehicleRate.width) return false;
        if (vehicleRate.height && productHeight > vehicleRate.height) return false;

        return true;
    };

    const getAvailableVehicleOptions = () => {
        if (!shippingRates || !inputs) {
            return [];
        }

        const productSpecs = {
            weight: inputs.weight?.value || '0',
            length: inputs.length?.value || '0',
            width: inputs.width?.value || '0',
            height: inputs.height?.value || '0'
        };

        return shippingRates.filter(rate =>
            validateProductAgainstVehicle(rate, productSpecs)
        );
    };

    const availableVehicleOptions = getAvailableVehicleOptions();
    const availableVehicleKeys = availableVehicleOptions.map(rate => rate.vehicle_type);

    // Check if all vehicle options are disabled
    const allVehiclesDisabled = availableVehicleKeys.length === 0 &&
        shippingRates &&
        (inputs.weight?.value || inputs.length?.value || inputs.width?.value || inputs.height?.value);

    // Auto-clear selected delivery option if it becomes invalid
    useEffect(() => {
        if (!shippingRates || !inputs) {
            return;
        }

        // Only run this effect if we have a selected pickup option
        if (inputs.pickup_option?.value) {
            // Check if the current selection is still valid
            const currentSelection = vehicleOptions.find(option => option.value === inputs.pickup_option.value);
            if (currentSelection) {
                const isStillValid = availableVehicleKeys.includes(currentSelection.key);
                if (!isStillValid) {
                    // Only clear if the current selection is no longer valid
                    handlerChange({ target: { name: 'pickup_option', value: '' } });
                } else {
                    // Clear validation error if selection is still valid
                    setDeliveryValidationError('');
                }
            }
        }
    }, [inputs.weight?.value, inputs.length?.value, inputs.width?.value, inputs.height?.value, shippingRates, inputs.pickup_option?.value]);

    // Set validation error when all vehicles are disabled
    useEffect(() => {
        if (allVehiclesDisabled) {
            setDeliveryValidationError('Product dimensions/weight exceed all available delivery options. Please adjust the specifications.');
        } else {
            setDeliveryValidationError('');
        }
    }, [allVehiclesDisabled]);

    const normalizedPickupOptionValue = React.useMemo(() => {
        const current = inputs.pickup_option?.value;
        if (!current) return '';
        const match = vehicleOptions.find(o => o.value === current || o.key === current);
        return match ? match.value : '';
    }, [inputs.pickup_option?.value]);

    const clearPickupFields = () => {
        const fields = [
            "pickup_branch_name", "street_name", "area_name", "pickup_branch_code", "pickup_province", "pickup_city", "pickup_barangay",
            "pickup_num", "nearest", "pickup_datetime", "full_address", "pickup_place_id"
        ];

        const clearedInputs = { ...inputs };

        fields.forEach(fieldName => {
            if (clearedInputs[fieldName]) {
                clearedInputs[fieldName] = {
                    ...clearedInputs[fieldName],
                    value: "",
                    stat: false,  // Clear error state
                    msg: ""       // Clear error message
                };
            }
        });
        console.log("clearedInputs: ", clearedInputs);

        prodTemplate.set({
            ...prodTemplate.data,
            inputs: clearedInputs
        });
    };

    // Open modal in add mode
    const handleOpenAddModal = () => {
        console.log("handle open modal called !!");
        clearPickupFields();
        console.log("clearPickupFields called !!");
        setIsDefault(false);
        setIsEnable(true);
        setPickupModal({ open: true, mode: 'add' });
    };

    const clearPickupFieldErrors = () => {
        const pickupFields = [
            "pickup_branch_name", "street_name", "area_name", "pickup_branch_code", "pickup_province", "pickup_city", "pickup_barangay",
            "pickup_num", "nearest", "pickup_datetime", "full_address"
        ];

        const clearedInputs = { ...inputs };

        pickupFields.forEach(fieldName => {
            if (clearedInputs[fieldName]) {
                clearedInputs[fieldName] = {
                    ...clearedInputs[fieldName],
                    stat: false,
                    msg: ''
                };
            }
        });

        prodTemplate.set({
            ...prodTemplate.data,
            inputs: clearedInputs
        });
    };

    const handleOpenViewModal = () => {
        clearPickupFieldErrors();

        if (selectedPickupAddress.data !== null) {
            const address = pickupAddresses.data[selectedPickupAddress.data];

            const fieldMappings = {
                pickup_branch_name: address.name || "",
                street_name: address.street_building_number || "",
                pickup_branch_code: address.code || "",
                area_name: address.area || "",
                full_address: address.full_address || "",
                pickup_place_id: address.place_id || "",
                pickup_province: address.province_id || "",
                pickup_city: address.city_id || "",
                pickup_barangay: address.barangay_id || "",
                pickup_num: address.contact_number || "",
                nearest: address.landmark || "",
                pickup_datetime: address.pickup_time || "",
            };
            console.log("address: ", address);
            console.log("fieldMappings: ", fieldMappings);

            const updatedInputs = { ...inputs };

            Object.entries(fieldMappings).forEach(([fieldName, value]) => {
                // handlerChange({ target: { name: fieldName, value }, });
                if (updatedInputs[fieldName]) {
                    updatedInputs[fieldName] = {
                        ...updatedInputs[fieldName],
                        value: value,
                        stat: false,  // Clear error state
                        msg: ""       // Clear error message
                    };
                }
            });

            prodTemplate.set({
                ...prodTemplate.data,
                inputs: updatedInputs
            });

            setIsDefault(address.is_default === 0 ? false : true);
            setIsEnable(address?.active !== undefined ? address?.active === 1 : true);
        }

        setPickupModal({ open: true, mode: 'view' });
    };

    const handleEditModal = () => {
        clearPickupFieldErrors();
        setPickupModal({ open: true, mode: 'edit' });
    };

    const handleClosePickupModal = () => {
        setPickupModal({ open: false, mode: 'view' });
    };
    
    const handleSavePickupAddress = async () => {
        selectedPickupAddress.set(pickupAddresses.data.length);
        if (hcrmSession === null) {
            let subId = env() === 'dev' || env() === 'local' ? 'c3Vic2NyaXB0aW9uXzUzMA==' : env() === 'sb' ? 'c3Vic2NyaXB0aW9uXzM3Mg==' : 'c3Vic2NyaXB0aW9uXzI2NQ=='
            localStorage.setItem('pickup_address', JSON.stringify(prodTemplate.data))
            window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${process.env.REACT_APP_TID_BIZ}`)}&callback=${process.env.REACT_APP_ENV}&platform=business&subscription=${subId}&ref=unauth&auth_type=registration&entry=ubr_subtool&subcb=pickup_address`
        }else{
            let newAddress;
            if (ubr_pickup_address) {
                newAddress = {
                    id: 0,
                    province_id: ubr_pickup_address.inputs.pickup_province?.value || 0,
                    city_id: ubr_pickup_address.inputs.pickup_city?.value || 0,
                    barangay_id: ubr_pickup_address.inputs.pickup_barangay?.value || 0,
                    street_building_num: ubr_pickup_address.inputs.street_name?.value || "",
                    company_id: __SESSION.data.uaccess[0].company_id,
                    user_id: userId.data,
                    branch_code: ubr_pickup_address.inputs.pickup_branch_code?.value || "",
                    branch_name: ubr_pickup_address.inputs.pickup_branch_name?.value || "",
                    full_address: ubr_pickup_address.inputs.full_address?.value || ""
                };
            }else{
                newAddress = {
                    id: 0,
                    province_id: inputs.pickup_province?.value || 0,
                    city_id: inputs.pickup_city?.value || 0,
                    barangay_id: inputs.pickup_barangay?.value || 0,
                    street_building_num: inputs.street_name?.value || "",
                    company_id: __SESSION.data.uaccess[0].company_id,
                    user_id: userId.data,
                    branch_code: inputs.pickup_branch_code?.value || "",
                    branch_name: inputs.pickup_branch_name?.value || "",
                    full_address: inputs.full_address?.value || ""
                };
            }
            const res = await rqx.post(`<<biz>>/${env()}/biz/branch/create`, newAddress);
            // Handle API errors for code_exists and name_exists
            if (res === "code_exist") {
                handlerChange({
                    target: {
                        name: "pickup_branch_code",
                        value: inputs.pickup_branch_code.value,
                    }
                }, undefined, { stat: true, msg: "Pickup warehouse code already exists" });
                if (ubr_pickup_address) {
                    prodTemplate.set(ubr_pickup_address)
                    localStorage.removeItem('pickup_address')
                }
                return;
            }
            else if (res === "name_exist") {
                handlerChange({
                    target: {
                        name: "pickup_branch_name",
                        value: inputs.pickup_branch_name.value,
                    }
                }, undefined, { stat: true, msg: "Pickup warehouse name already exists" });
                if (ubr_pickup_address) {
                    prodTemplate.set(ubr_pickup_address)
                    localStorage.removeItem('pickup_address')
                }
                return;
            }

            // Only execute this block if there were no errors //if (res !== "code_exist" && res !== "name_exist") {
            if (res && typeof res === 'object' && res.id) {
                let bdy;
                if (ubr_pickup_address) {
                    bdy = {
                        company_branch_id: res.id,
                        area: ubr_pickup_address.inputs?.area_name?.value,
                        contact_number: ubr_pickup_address.inputs?.pickup_num?.value,
                        landmark: ubr_pickup_address.inputs?.nearest?.value,
                        pickup_time: ubr_pickup_address.inputs?.pickup_datetime?.value,
                        place_id: ubr_pickup_address.inputs.pickup_place_id?.value || "",
                        is_default: isDefault ? 1 : pickupAddresses.data.length <= 0 ? 1 : 0,
                        user_id: userId.data,
                        active: isEnable ? 1 : 0
                    }
                }else{
                    bdy = {
                        company_branch_id: res.id,
                        area: inputs?.area_name?.value,
                        contact_number: inputs?.pickup_num?.value,
                        landmark: inputs?.nearest?.value,
                        pickup_time: inputs?.pickup_datetime?.value,
                        place_id: inputs.pickup_place_id?.value || "",
                        is_default: isDefault ? 1 : pickupAddresses.data.length <= 0 ? 1 : 0,
                        user_id: userId.data,
                        active: isEnable ? 1 : 0
                    }
                }
                await rqx.post(`<<tool>>/${env()}/template/create_pickup_details`, bdy);
                await fetchPickupAddress();
                setIsDefault(false);
                setIsEnable(true);
                if (ubr_pickup_address) {
                    prodTemplate.set(ubr_pickup_address)
                    localStorage.removeItem('pickup_address')
                }
                handleClosePickupModal();
            }
        }
        
    };

    const handleSaveUpdatePickupAddress = async () => {
        try {
            const selectedIdx = selectedPickupAddress.data;
            const selectedAddress = pickupAddresses.data[selectedIdx];
            const id = selectedAddress?.id;
            const branchId = selectedAddress?.company_branch_id;
            const updateAddress = {
                id: branchId,
                province_id: inputs.pickup_province?.value || 0,
                city_id: inputs.pickup_city?.value || 0,
                barangay_id: inputs.pickup_barangay?.value || 0,
                street_building_num: inputs.street_name?.value || "",
                company_id: __SESSION.data.uaccess[0].company_id,
                user_id: userId.data,
                branch_code: inputs.pickup_branch_code?.value || "",
                branch_name: inputs.pickup_branch_name?.value || "",
                full_address: inputs.full_address?.value || "",
                active: isEnable ? 1 : 0
            };
            const res = await rqx.post(`<<biz>>/${env()}/biz/branch/update`, updateAddress);
            if (res) {
                const bdy = {
                    id: id,
                    company_branch_id: branchId,
                    area: inputs.area_name.value,
                    contact_number: inputs.pickup_num.value,
                    landmark: inputs.nearest.value,
                    place_id: inputs.pickup_place_id?.value || "",
                    pickup_time: inputs.pickup_datetime.value,
                    is_default: isDefault ? 1 : 0,
                    user_id: userId.data,
                    active: isEnable ? 1 : 0
                }
                const res = await rqx.post(`<<tool>>/${env()}/template/update_pickup_details`, bdy);
                console.log("Response : ", res);
                fetchPickupAddress();
                handleClosePickupModal();
            }
        } catch (error) {
            console.log("error from update", error)
        }
    };

    const handleSelectPickupAddress = (idx) => {
        selectedPickupAddress.set(idx);
        const address = pickupAddresses.data[idx];

        const fieldMappings = {
            pickup_branch_name: address.name || "",
            street_name: address.street_building_number || "",
            full_address: address.full_address || "",
            pickup_place_id: address.place_id || "",
            area_name: address.area || "",
            pickup_province: address.province_id || "",
            pickup_city: address.city_id || "",
            pickup_barangay: address.barangay_id || "",
            pickup_num: address.contact_number || "",
            nearest: address.landmark || "",
            pickup_datetime: address.pickup_time || "",
            pickup_branch_code: address.code || "",
        };

        if (prodTemplate && prodTemplate.set) {
            const updatedInputs = { ...inputs };

            Object.entries(fieldMappings).forEach(([fieldName, value]) => {
                if (updatedInputs[fieldName]) {
                    updatedInputs[fieldName] = {
                        ...updatedInputs[fieldName],
                        value: value,
                        stat: false,  // Clear error state
                        msg: ""       // Clear error message
                    };
                }
            });

            prodTemplate.set({
                ...prodTemplate.data,
                inputs: updatedInputs
            });
        }
        setIsDefault(address?.is_default || false);
        setIsEnable(address?.active !== undefined ? address?.active === 1 : true);
    };

    const handleDefaultChange = (e) => {
        const checked = e.target.checked;
        setIsDefault(checked);
    };

    const handleEnableChange = (e) => {
        const checked = e.target.checked;
        setIsEnable(checked);
    };
    const defaultPickupIndex = pickupAddresses.data.findIndex(addr => addr?.is_default);

    const handleLocationSelect = async (coords) => {
        setPickupCoordinates(coords);
        if (coords.details) {
            // handlerChange({ target: { name: 'full_address', value: coords.details } });
            prodTemplate.set({
                ...prodTemplate.data,
                inputs: {
                    ...prodTemplate.data.inputs,
                    full_address: { value: coords.details, stat: false, msg: '' },
                    pickup_place_id: { value: coords.place_id || '', stat: false, msg: '' }
                }
            })
            setSelectedAddressDetails(coords.details);
        } else {
            const details = await getAddressFromLatLng(
                coords.lat,
                coords.lng,
                process.env.REACT_APP_GOOGLE_API_KEY
            );
            setSelectedAddressDetails(details);
            prodTemplate.set({
                ...prodTemplate.data,
                inputs: {
                    ...prodTemplate.data.inputs,
                    full_address: { value: details.formatted_address || '', stat: false, msg: '' },
                    pickup_place_id: { value: details.place_id || '', stat: false, msg: '' }
                }
            })
        }
        setIsGoogleMapsMode(true);
        const fieldsToClear = ['street_name', 'area_name', 'pickup_province', 'pickup_city', 'pickup_barangay'];
        fieldsToClear.forEach(field => {
            handlerChange({ target: { name: field, value: '' } });
        });
        setOpen(false);
    };

    const handleAddressConfirm = (updatedDetails) => {
        setSelectedAddressDetails(updatedDetails);
        setConfirmAddressModalOpen(false);
        clearPickupFields();
        setIsDefault(false);
        setIsEnable(true);
        setPickupModal({ open: true, mode: 'add' });
    };

    const handleMapLocationPicked = (location) => {
        setPickupCoordinates(location);
    };

    const handleDecimalKeyPress = (e) => {
        const key = e.key;
        const currentValue = e.target.value;

        // Allow control keys (backspace, delete, tab, escape, enter, etc.)
        if (key === 'Backspace' || key === 'Delete' || key === 'Tab' ||
            key === 'Escape' || key === 'Enter' || key === 'ArrowLeft' ||
            key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown' ||
            (key === 'a' && e.ctrlKey) || (key === 'c' && e.ctrlKey) ||
            (key === 'v' && e.ctrlKey) || (key === 'x' && e.ctrlKey)) {
            return;
        }

        // Allow digits (0-9)
        if (key >= '0' && key <= '9') {
            return;
        }

        // Allow decimal point only if there isn't one already
        if (key === '.' && !currentValue.includes('.')) {
            return;
        }

        // Block all other characters
        e.preventDefault();
    };
    
    useEffect(() => {
        const runUbr = async () => {
            if (ubr_pickup_address) {
                prodTemplate.set(ubr_pickup_address)
                setPickupModal({ open: true, mode: 'add' });
                const sub_cat = await rqx.get(`<<tool>>/${env()}/template/subcategory`, { category_id: ubr_pickup_address.inputs.category.value })
                subCategory.set(sub_cat)
            }
        }
        runUbr()
        // eslint-disable-next-line
    },[])
    
    return (
        <Box p={2} display="flex" flexDirection="column" gap="8px" height="100%" width="100%">
            <Box display="flex" fontWeight={600}>Promo Name Title <Box color="#FA3E3E">*</Box></Box>
            <TextField size="small" name="title" onChange={(e) => handlerChange(e)}
                value={inputs.title.value} error={inputs.title.stat} helperText={inputs.title.msg}
                multiline
                maxRows={3}
                minRows={3}
                inputProps={{ maxLength: 50 }}
            />
            <Box display="flex" fontWeight={600}>Product Name<Box color="#FA3E3E">*</Box></Box>
            <TextField size="small" name="promo_caption" onChange={(e) => handlerChange(e)}
                value={inputs.promo_caption.value} error={inputs.promo_caption.stat} helperText={inputs.promo_caption.msg}
                multiline
                maxRows={3}
                minRows={3}
                inputProps={{ maxLength: 100 }}
            />
            <Box display="flex" justifyContent="space-between">
                <Box display="flex" fontWeight={600}>Promo Details <Box color="#FA3E3E">*</Box></Box>
                <Box component={Button} onClick={() => handlerDetails('add')}>
                    <AddBox1 stroke="#2D503E" width={20} />
                </Box>
            </Box>
            {
                inputs.promo_details.map((v, k) => (
                    <Box display="flex" alignItems="center" gap="8px" key={k}>
                        <TextField size='small' name="promo_details" onChange={(e) => handlerChange(e, k)}
                            value={v.value} error={v.stat} helperText={v.msg}
                        />
                        <Box component={Button} onClick={() => handlerDetails('remove', k)}>
                            <Remove sx={{ color: '#FA3E3E' }} />
                        </Box>
                    </Box>
                ))
            }
            <Box display="flex" fontWeight={600}>Regular Price <Box color="#FA3E3E">*</Box></Box>
            <NumericFormat customInput={TextField} size='small' name="reg_price" onChange={(e) => handlerChange(e)}
                thousandSeparator=","
                value={inputs.reg_price.value} error={inputs.reg_price.stat} helperText={inputs.reg_price.msg}
            />
            <Box fontWeight={600}>Discount in Percent</Box>
            <TextField size="small" name="discount_percent" onChange={(e) => handlerChange(e)}
                onKeyPress={validateDisc}
                value={inputs.discount_percent.value}
            />
            <Box fontWeight={600}>Rate</Box>
            <TextField size="small" name="rate" onChange={(e) => handlerChange(e)} disabled
                onKeyPress={ValidateInt}
                value={
                    inputs.discount_percent.value !== '.' && inputs.discount_percent.value !== '' && inputs.reg_price.value !== '' ?
                        Number((parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) - (parseFloat(inputs.reg_price.value.replace(/,(?=\d{3})/g, '')) * (parseFloat(inputs.discount_percent.value) / 100))).toFixed(2)).toLocaleString()
                        :
                        0
                }
            />
            <Box display="flex" alignItems="center">
                <Checkbox name="partial" checked={inputs.partial.toggled} onChange={(e) => handlerCheck(e)} />
                <Box fontSize={14} fontWeight={600} display="flex">Accept Partial Payment</Box>
            </Box>
            {
                inputs.partial.toggled &&
                <>
                    <Box fontSize={14} fontWeight={600} mb={0.5} display="flex">Partial Payment</Box>
                    <TextField name="partial" variant="outlined" fullWidth size="small"
                        type="number"
                        onChange={(e) => handlerChange(e)}
                        disabled={!inputs.partial.toggled} value={inputs.partial.value}
                        error={inputs.partial.stat} helperText={inputs.partial.msg} inputProps={{ min: 1 }}
                    />
                </>
            }
            <Box display="flex" fontWeight={600}>Product Category <Box color="#FA3E3E">*</Box></Box>
            <FormControl error={inputs.category.stat} fullWidth size='small'>
                <InputLabel id="category">Select Category</InputLabel>
                <Select name="category" labelId='category' label="Select Category" onChange={(e) => handlerChange(e)}
                    value={inputs.category.value}
                    MenuProps={{
                        PaperProps: {
                            sx: { maxHeight: 280, width: 250, overflowY: 'scroll' }
                        },
                    }}
                >
                    {
                        categoryList.data.map((v, k) => (
                            <MenuItem value={v.id} key={k}>{v.name}</MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>{inputs.category.msg}</FormHelperText>
            </FormControl>
            <Box display="flex" fontWeight={600}>Sub Category <Box color="#FA3E3E">*</Box></Box>
            <FormControl error={inputs.sub_category.stat} fullWidth size='small'>
                <InputLabel id="sub_category">Select Sub-Category</InputLabel>
                <Select name="sub_category" labelId='sub_category' label="Selec Sub-Category" onChange={(e) => handlerChange(e)}
                    value={inputs.sub_category.value}
                    disabled={subCategory.data.length === 0}
                    MenuProps={{
                        PaperProps: {
                            sx: { maxHeight: 160, width: 250, overflowY: 'scroll' }
                        }
                    }}
                >
                    {
                        subCategory.data.map((v, k) => (
                            <MenuItem value={v.id} key={k}>{v.name}</MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>{inputs.sub_category.msg}</FormHelperText>
            </FormControl>
            <Box>
                <Box fontWeight={600} display="flex">Product Weight<Box color="#FA3E3E">*</Box></Box>
                <TextField
                    size="small"
                    name="weight"
                    onChange={(e) => handlerChange(e)}
                    onKeyPress={handleDecimalKeyPress}
                    value={inputs?.weight?.value}
                    error={inputs?.weight?.stat}
                    helperText={inputs?.weight?.msg}
                />
            </Box>
            <Box fontWeight={600}>Product Dimensions in cm</Box>
            <Box display="flex" gap="16px" alignItems="flex-start">
                <Box>
                    <Box fontSize={14} fontWeight={500} display="flex" mb={1}>Length<Box color="#FA3E3E">*</Box></Box>
                    <TextField
                        value={inputs?.length?.value}
                        error={inputs?.length?.stat}
                        helperText={inputs?.length?.msg}
                        size="small"
                        name="length"
                        onChange={(e) => handlerChange(e)}
                        onKeyPress={handleDecimalKeyPress}
                        sx={{ width: '80px' }}
                    />
                </Box>
                <Box>
                    <Box fontSize={14} fontWeight={500} display="flex" mb={1}>Width<Box color="#FA3E3E">*</Box></Box>
                    <TextField
                        value={inputs?.width?.value}
                        error={inputs?.width?.stat}
                        helperText={inputs?.width?.msg}
                        size="small"
                        name="width"
                        onChange={(e) => handlerChange(e)}
                        onKeyPress={handleDecimalKeyPress}
                        sx={{ width: '80px' }}
                    />
                </Box>
                <Box>
                    <Box fontSize={14} fontWeight={500} display="flex" mb={1}>Height<Box color="#FA3E3E">*</Box></Box>
                    <TextField
                        value={inputs?.height?.value}
                        error={inputs?.height?.stat}
                        helperText={inputs?.height?.msg}
                        size="small"
                        name="height"
                        onChange={(e) => handlerChange(e)}
                        onKeyPress={handleDecimalKeyPress}
                        sx={{ width: '80px' }}
                    />
                </Box>
            </Box>
            <FormControl error={inputs.pickup.stat || inputs.delivery.stat} fullWidth size='small'>
                <Box fontWeight={600} display="flex">Open for: <Box color="#FA3E3E">*</Box></Box>
                <Box display="flex" alignItems="center" gap="8px">
                    <Checkbox name="pickup" checked={inputs.pickup.value} onChange={(e) => handlerChange(e)} />
                    <Box>Pickup</Box>
                </Box>
                <Box display="flex" alignItems="center" gap="8px">
                    <Checkbox name="delivery" checked={inputs.delivery.value} onChange={(e) => handlerChange(e)} />
                    <Box>Delivery</Box>
                </Box>
                <FormHelperText>{inputs.delivery.msg}</FormHelperText>
            </FormControl>
            {
                inputs.delivery.value && (
                    <>
                        <Box px={2} display="flex" flexDirection="column" gap="8px">
                            <FormControl error={inputs.delivery_option.value === ''}>
                                <RadioGroup value={inputs.delivery_option.value} onChange={(e) => handlerChange(e)}>
                                    <FormControlLabel name="delivery_option" value="free_ship" control={<Radio />} label='Free Shipping' />
                                    <FormControlLabel name="delivery_option" value="apply_set_del" control={<Radio />} label='Apply Set Delivery Rate' />
                                </RadioGroup>
                                {
                                    inputs.delivery_option.value === '' &&
                                    <FormHelperText>Required to choose one</FormHelperText>
                                }
                            </FormControl>
                            {/* <Box>Processing time in hr</Box>
                        <Box display="flex" alignItems="center">
                            <TextField label="Hours" name="processing_time" onKeyPress={ValidateInt} onChange={(e) => handlerChange(e)} sx={{width: 100}}  
                                inputProps={{ maxLength: 2 }}
                            />
                        </Box> */}
                        </Box>
                        <FormControl error={inputs.pickup_option.value === '' || !!deliveryValidationError || allVehiclesDisabled} fullWidth>
                            <Box sx={{ fontWeight: 600, display: 'flex', mb: 1 }}>Delivery Options <Box color="#FA3E3E">*</Box></Box>
                            <Box px={2} display="flex" flexDirection="column" gap="8px">
                                <RadioGroup row name="pickup_option" value={normalizedPickupOptionValue}
                                    onChange={(e) => {
                                        handlerChange(e);
                                        setDeliveryValidationError(''); // Clear error when user makes selection
                                    }}
                                >
                                    {vehicleOptions.map(option => {
                                        const isAvailable = availableVehicleKeys?.includes(option.key);
                                        return (
                                            <FormControlLabel
                                                key={option.value}
                                                value={option.value}
                                                control={<Radio />}
                                                label={option.label}
                                                disabled={!isAvailable || allVehiclesDisabled}
                                                sx={{
                                                    opacity: isAvailable && !allVehiclesDisabled ? 1 : 0.5,
                                                    '& .MuiFormControlLabel-label': {
                                                        color: isAvailable && !allVehiclesDisabled ? 'inherit' : 'text.disabled'
                                                    }
                                                }}
                                            />
                                        );
                                    })}
                                </RadioGroup>
                                {(inputs.pickup_option.value === '' || deliveryValidationError || allVehiclesDisabled) && (
                                    <FormHelperText error>
                                        {deliveryValidationError ||
                                            (allVehiclesDisabled ? 'Product specifications exceed all available delivery options' : 'Required to choose one')}
                                    </FormHelperText>
                                )}
                            </Box>
                        </FormControl>
                    </>
                )
            }
            <Box fontWeight={600} display="flex" alignItems="center">
                <Box>Pickup or Product origin Address</Box>
                <Box color="#FA3E3E">*</Box>
            </Box>
            {pickupAddresses.data.length > 0 ? (
                <Box mb={1} display='flex' justifyContent='space-between' alignItems='center' gap='10px'>
                    <FormControl size="small" fullWidth>
                        <Select
                            value={selectedPickupAddress.data !== null ? selectedPickupAddress.data : (defaultPickupIndex !== -1 ? defaultPickupIndex : pickupAddresses.data.length - 1)}
                            // value={selectedPickupAddress.data !== null ? selectedPickupAddress.data : (defaultPickupIndex !== -1 ? defaultPickupIndex : '')}
                            onChange={e => {
                                if (e.target.value === 'add_address') {
                                    handleOpenAddModal();
                                } else {
                                    handleSelectPickupAddress(e.target.value);
                                }
                            }}
                            displayEmpty
                            input={
                                <OutlinedInput
                                    sx={{
                                        paddingRight: '36px',
                                        fontSize: 14,
                                    }}
                                    endAdornment={
                                        (selectedPickupAddress.data !== null && selectedPickupAddress.data !== "add_address") && (
                                            <InputAdornment position="end" sx={{ cursor: 'pointer', ml: 1 }}>
                                                <VisibilityIcon
                                                    color="action"
                                                    fontSize="small"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        handleOpenViewModal();
                                                    }}
                                                />
                                            </InputAdornment>
                                        )
                                    }
                                />
                            }
                        >
                            {pickupAddresses.data.map((addr, idx) => (
                                <MenuItem value={idx} key={idx} sx={{ fontSize: 14 }}>
                                    {addr.name || `Address ${idx + 1}`}
                                    {addr.is_default ? " (Default)" : ""}
                                </MenuItem>
                            ))}
                            <MenuItem value="add_address" key="add_address" sx={{ color: 'primary.main', fontWeight: 600, fontSize: 14 }}>
                                + Add New Address
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            ) : (
                <Button variant="outlined" onClick={handleOpenAddModal} sx={{ color: 'primary.main', fontWeight: 600, fontSize: 14 }}>
                    + Add New Address
                </Button>
            )}

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box>
                    <GoogleMapPicker
                        onLocationSelect={handleLocationSelect}
                        initialLocation={pickupCoordinates}
                        onClose={() => setOpen(false)}
                    />
                </Box>
            </Modal>
            <PickupAddressModal
                open={pickupModal.open}
                mode={pickupModal.mode}
                onClose={handleClosePickupModal}
                onSave={handleSavePickupAddress}
                onEdit={handleEditModal}
                onSaveUpdate={handleSaveUpdatePickupAddress}
                inputs={inputs}
                prodTemplate={prodTemplate}
                provinces={provinces}
                cities={cities}
                barangay={barangay}
                provinceLoading={provinceLoading}
                cityLoading={cityLoading}
                barangayLoading={barangayLoading}
                handlePickupFieldChange={handlerChange}
                isDefault={isDefault}
                isEnable={isEnable}
                handleDefaultChange={handleDefaultChange}
                handleEnableChange={handleEnableChange}
                onOpenMap={handleOpen}
                onMapSelect={handleMapLocationPicked}
                selectedAddressDetails={selectedAddressDetails}
                isGoogleMapsMode={isGoogleMapsMode}
                setIsGoogleMapsMode={setIsGoogleMapsMode}
                ubr_pickup_address={ubr_pickup_address}
            />
            <ConfirmAddressModal
                open={confirmAddressModalOpen}
                onClose={() => setConfirmAddressModalOpen(false)}
                selectedAddressDetails={selectedAddressDetails}
                onConfirm={handleAddressConfirm}
            />
            <Box minHeight={30} />
        </Box>
    )
}
